module.exports = __webpack_public_path__ + "static/media/trash.bold.9e94b87c.svg";